export const ROUTES = {
    home: '/',
    series: '/series',
    seriesDetails: '/series-details',
    contact: '/contact-us',
    moviedetails: '/video-details',
    signup: '/sign-up',
    profile: '/profile',
    profile_edit: "/profile_edit",
    profile_selection: "/profile_selection",
    complaint: "/complaint",
    my_account: "/my_account",
    device_management: "/device_management",
    edit_account: "/edit_account",
    transaction_history: "/transaction_history",
    change_password: "/change_password",
    forgot_password: "/forgot_password",
    priceplan: '/price-plan',
    watchlist: '/watchlist',
    video: '/video',
    stream: '/stream',
    moviesByLanguage: '/selected-language-movies',
    moviesByGenre: '/selected-genre-movies',
    movies: '/videos',
    shortfilms: '/short-films',
    trailer: '/locality-video',
    episode: '/series-episode',
    logoutwithOTP: '/logout-otp',
    categories: '/categories',
    videosByCategory: '/videos-by-category',
    digitalForm: '/digital-submission',
    videoByArea: '/area',
    locality: '/locality',
    videoByTags:'/video-by-tags',
    competitionForm:'/competition-form'

};